module.exports = __webpack_public_path__ + "static/construction-67eb7b8e55300de7a328d875f28fc293.svg";